import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class DriverDashboardService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetUpcomingBooking(input?: DataListModel): Observable<IAPIResponse> {
    let getUpcomingBookingUrl = WeGoConfig.API_GET_UPCOMING_BOOKING_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getUpcomingBookingUrl = getUpcomingBookingUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUpcomingBookingUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/models/driver-dashboard.service.ts